import { render, staticRenderFns } from "./BannerHeaderDesktop.vue?vue&type=template&id=a47bc2dc&"
import script from "./BannerHeaderDesktop.vue?vue&type=script&lang=ts&"
export * from "./BannerHeaderDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports